<template>
  <el-form ref="creativeForm" :model="creativeModel" :rules="rules" label-width="117px" label-position="left">
    <ContentBox>
      <div class="card-custom-title" slot="title">
        <div>素材列表</div>
        <div>
          <i class="card-custom-icon el-icon-picture-outline" @click="showMediaDialog = true">从素材库选择</i>
        </div>
      </div>
      <PageMediaTable
        ref="pageMedia"
        :mediaList="creativeModel.mediaList"
        :brandIcon="brandIcon"
        :bgImage="bgImage"
        @change="handleMediaListChange"
      />
    </ContentBox>
    <ContentBox title="打底素材" v-if="showTargetEvent && scheduleForm.supportMode === 2">
      <el-form-item label="设置打底素材" prop="backupMediaId">
        <el-col :span="22">
          <el-select v-model="creativeModel.backupMediaId">
            <el-option
              v-for="(item, index) in creativeModel.mediaList"
              :key="index"
              :label="item.mediaName"
              :value="item.mediaId"
            >
            <span style="float: left">{{ item.mediaName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mediaId }}</span>
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="打底交互事件">
        <el-radio-group v-model="creativeModel.backupShipType" @change="handleBackupShipTypeChange">
          <el-radio-button label="NONE">无</el-radio-button>
          <el-radio-button v-for="event in eventOptions" :key="event.shipType" :label="event.shipType">{{ event.name }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="creativeModel.backupShipType !== 'NONE'">
        <div class="event-wrapper">
          <TargetEventItem
            :partnerId="scheduleForm.partnerId"
            :ship-type="creativeModel.backupShipType"
            :model="creativeModel.backupTargetEvent"
            :eventTempList="eventTempList"
          />
        </div>
      </el-form-item>
    </ContentBox>
    <ContentBox title="监测代码">
      <template v-if="scheduleForm.supportMode === 2">
        <el-form-item label="监测代码" >
          <el-col :span="22">
            <el-radio-group v-model="codeType" @input="confirmClearCodeType">
              <el-radio-button
                class="code-radio"
                :label="item.label"
                :key="index"
                v-for="(item, index) in codeTypePDBOptions"
              >{{ item.value }}</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="22">
            <el-tabs v-model="trackType" type="border-card" style="padding: 0">
              <el-tab-pane
                v-for="item in showingTrackOptions"
                :key="item.queue"
                :label="`${item.name}(${creativeModel[item.key].length})`"
                :name="item.key"
              >
                <MediaTrack
                  :trackKey="item.type"
                  :trackTypeList="trackTypeList"
                  :sdkProviderList="sdkProviderList"
                  :providerList="providerList"
                  :trackList="creativeModel[item.key]"
                  :supportPointTrack="supportPointTrack"
                  :pointList="pointList"
                ></MediaTrack>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-form-item>
      </template>
      <template v-if="showMobileTrack">
        <el-form-item label="移动端监测">
          <el-radio-group v-model="creativeModel.useMobileTrack" @change="handleUseMobileTrackChange">
            <el-radio-button :label="0">不使用</el-radio-button>
            <el-radio-button :label="1">使用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="creativeModel.useMobileTrack === 1" label="">
          <div v-for="(mTrack, mIdx) in creativeModel.mobileTrackList" :key="mIdx" class="flex-form-item">
            <el-select :value="mTrack.trackTypeModel" disabled>
              <el-option :value="1" label="API类型"></el-option>
            </el-select>
            <el-select v-model="mTrack.serviceProvider" placeholder="监测商">
              <el-option v-for="(opt,idx) in providerList" :key="idx" :value="opt.providerNo" :label="opt.providerName"></el-option>
            </el-select>
            <el-input v-model="mTrack.code" placeholder="请输入监测代码" clearable></el-input>
            <el-button @click="handleMobileTrackDel(mIdx)">删除</el-button>
          </div>
          <el-button type="primary" @click="handleMobileTrackAdd">增加代码</el-button>
        </el-form-item>
      </template>
      <el-form-item label="结算监测类型">
        <el-col :span="22">
          <el-radio-group v-model="creativeModel.settlementType" @change="handleStTypeChange">
            <el-radio-button
              v-for="(item, index) in settlementTypeOptions"
              :label="item.label"
              :key="index"
              >{{ item.value }}</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-form-item>
      <el-form-item v-if="creativeModel.settlementType !== 0" label="结算监测商" prop="settlementProvider">
        <el-col :span="22">
          <el-select v-model="creativeModel.settlementProvider">
            <el-option
              v-for="(item, index) in stProviderList"
              :key="index"
              :label="item.providerName"
              :value="item.providerNo"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </ContentBox>
    <ContentBox title="素材配置">
      <template v-if="showTargetEvent">
        <el-form-item label="交互事件">
          <el-radio-group v-model="creativeModel.shipType" @change="handleShipTypeChange">
            <el-radio-button label="NONE">无</el-radio-button>
            <el-radio-button v-for="event in eventOptions" :key="event.shipType" :label="event.shipType">{{ event.name }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="creativeModel.shipType !== 'NONE'">
          <div class="event-wrapper">
            <TargetEventItem
              :partnerId="scheduleForm.partnerId"
              :ship-type="creativeModel.shipType"
              :model="creativeModel.targetEvent"
              :eventTempList="eventTempList"
              @temp-change="handleTargetEventChange"
            />
          </div>
        </el-form-item>
      </template>
      <el-form-item label="提示语">
        <el-col :span="22">
          <AdTipsEditorNew
            ref="tipsEditor"
            :tipsTempId="creativeModel.tipsTempId"
            :tipsDetail="creativeModel.tipsDetail"
            :spaceId="scheduleForm.spaceId"
            :targetEventType="creativeModel.targetEventType"
            @change-tips="saveTips"
          />
        </el-col>
      </el-form-item>
      <!-- 选了交互事件才有落地页监测 -->
      <template v-if="existTargetEvent">
        <el-form-item label="落地页监测">
          <el-radio-group v-model="landingTrackType" @change="handleLandingTrackTypeChange">
            <el-radio-button :label="0">不使用</el-radio-button>
            <el-radio-button :label="1">使用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="landingTrackType === 1" label="">
          <el-col :span="22">
            <el-tabs v-model="trackTypeLanding" type="border-card" style="padding: 0">
              <el-tab-pane
                v-for="item in landingTrackOptions"
                :key="item.queue"
                :label="`${item.name}(${creativeModel[item.key + 'Landing'].length})`"
                :name="item.key"
              >
                <MediaTrack :providerList="providerList" :trackList="creativeModel[item.key + 'Landing']"></MediaTrack>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-form-item>
        <el-form-item label="落地页提示">
          <LandingPageTips
            :init-tips-detail="creativeModel.landingTipsDetail[0]"
            @tips-change="setLandingPageTips"
          />
        </el-form-item>
      </template>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button plain @click="handleGoBack">返回</el-button>
      <el-button type="primary" :loading="saveLoading" @click="saveCreative">提交送审</el-button>
    </ContentBox>
    <!-- 素材选择弹窗 -->
    <MediaListDialog
      v-model="showMediaDialog"
      :mediaQuery="{
        checkStatusArray: [4],
        width: recStreamInfo ? recStreamInfo.mediaWidth : undefined,
        height: recStreamInfo ? recStreamInfo.mediaHeight : undefined
      }"
      :multiple="true"
      :mediaList="creativeModel.mediaList"
      :orderScheduleForm="scheduleForm"
      @go-back="showMediaDialog = false"
      @selected-media="handleSelectedMedia"
    ></MediaListDialog>
  </el-form>
</template>

<script>
import MediaTrack from '@/components/MediaTrack'
import PageMediaTable from './components/PageMediaTable.vue'
import MediaListDialog from '@/components/CommonUploadTable.vue'
import LandingPageTips from '../creative/components/LandingPageTips.vue'
import {
  codeTypePDBOptions,
  settlementTypeOptions,
  trackOptions,
  eventOptions,
  eventEnum,
  trackTypeObj,
  genTargetEvent,
  genTracks,
  genTracksLanding
} from './MaterialCreative'
import { setTargetEventDetail, checkTargetEvent, checkTrackCode, checkRegEx } from './creativeUtil'
import AdTipsEditorNew from '@/components/media/AdTipsEditorNew.vue'
import { uniq, uniqBy } from 'lodash'
import TargetEventItem from '@/components/targetEvent/TargetEventItem.vue'

export default {
  components: {
    MediaTrack,
    PageMediaTable,
    MediaListDialog,
    LandingPageTips,
    AdTipsEditorNew,
    TargetEventItem
  },
  props: {
    scheduleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sdkProviderList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const validateSettlementProvider = (rule, value, callback) => {
      if (this.creativeModel.settlementType !== 0 && !value) {
        callback(new Error('请选择监测商'))
      } else {
        callback()
      }
    }
    return {
      creativeModel: {
        tipsTempId: undefined,
        tipsDetail: '',
        shipType: 'NONE',
        targetEventType: 4, // 交互事件类型，默认4-无交互事件
        targetEvent: genTargetEvent(),
        ...genTracks(),
        ...genTracksLanding(),
        settlementType: 0,
        settlementProvider: '',
        mediaList: [],
        backupMediaId: '',
        landingTipsDetail: [''],
        backupShipType: 'NONE',
        backupTargetEvent: genTargetEvent(),
        useMobileTrack: 0,
        mobileTrackList: [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
      },
      landingTrackType: 0,
      codeTypePDBOptions,
      settlementTypeOptions,
      trackOptions,
      eventOptions,
      codeType: 1,
      trackType: 'trackList',
      trackTypeLanding: 'trackList',
      providerList: [],
      providerMap: new Map(), // 监测商Map
      ownProvider: {},
      macroMap: {},
      rules: {
        backupMediaId: [{ required: true, message: '打底素材不能为空', trigger: 'blur' }],
        settlementProvider: [{ validator: validateSettlementProvider, trigger: 'blur' }]
      },
      showMediaDialog: false,
      adTip: 1,
      brandIcon: 0,
      bgImage: 0,
      defaultTipsTempId: undefined,
      defaultTipsDetail: '',
      trackTypeList: [],
      saveLoading: false,
      recStreamInfo: null,
      showTargetEvent: false,
      supportPointTrack: false,
      pointList: [],
    }
  },
  computed: {
    // 是否已选交互事件
    existTargetEvent() {
      return this.creativeModel.shipType !== 'NONE' && this.creativeModel.targetEvent.targetTempId > -1
    },
    stProviderList() {
      // CPDB结算监测从已填监测商中选， PD/PDB从所有监测商中选
      let resList = this.providerList
      if (this.scheduleForm.supportMode === 2) {
        const settlementType = this.creativeModel.settlementType
        const providerNos = (this.creativeModel[trackTypeObj[settlementType]] || []).map(item => {
          return item.serviceProvider
        })
        resList = this.providerList.filter(item => providerNos.includes(item.providerNo))
      }
      return resList
    },
    showMobileTrack() {
      return this.scheduleForm.spaceNo === 'CCADTV10040'
    },
    landingTrackOptions() {
      return trackOptions.filter(opt => opt.key !== 'pointTrackList')
    },
    showingTrackOptions() {
      if (this.supportPointTrack) {
        return trackOptions
      }
      return trackOptions.filter(opt => opt.key !== 'pointTrackList')
    },
  },
  inject: ['eventTempList'],
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.getProviderMap()
      this.getOwnTrackProvider()
      const spaceModel = await this.$service.getSpaceModelById({ spaceId: this.scheduleForm.spaceId })
      this.adTip = spaceModel.adTip
      this.brandIcon = spaceModel.brandIcon
      this.bgImage = spaceModel.bgImage
      this.showTargetEvent = spaceModel.targetEvent === 1
      this.trackTypeList = spaceModel.trackTypeList ? JSON.parse(spaceModel.trackTypeList) : []
      this.supportPointTrack = spaceModel.pointTrack === 1
      // 获取定点监测时间选项
      if (this.supportPointTrack) {
        this.getPointList()
      }
      // 品牌商城广告获取推荐流尺寸
      if (this.scheduleForm.spaceNo === 'CCADTV10036' && this.scheduleForm.recId) {
        this.getRecStreamInfo()
      }
      await this.genSpaceTemps()
      this.initCreativeDetail()
    },
    getPointList() {
      this.$service.getPointList().then((res) => {
        this.pointList = res
      })
    },
    genSpaceTemps() {
      return this.$service
        .getAdDefaultTip({ spaceId: this.scheduleForm.spaceId, defFlagType: 0 })
        .then((res) => {
          if (res) {
            this.defaultTipsTempId = res.tempId
            this.defaultTipsDetail = res.tipsDetail ? JSON.stringify(res.tipsDetail) : ''
          }
        })
    },
    initCreativeDetail() {
      const scheduleId = this.scheduleForm.scheduleId
      this.$emit('set-loading', true)
      this.$service.scheduleMediaDetails(scheduleId).then(res => {
        this.$emit('set-loading', false)
        if (!res || !res.programmedScheduleMedia) {
          return
        }
        const model = {
          tipsTempId: res.tipsTempId,
          tipsDetail: res.tipsDetail,
          settlementType: res.settlementType,
          settlementProvider: res.settlementProvider,
          mediaList: res.mediaVOList.map(item => {
            if (item.mateType === 'md5') {
              item.mateHash = item.mateCheckCode
            }
            return item
          }),
          backupMediaId: res.backupMediaId,
          ...res.programmedScheduleMedia,
          ...setTargetEventDetail(res.programmedScheduleMedia, this.eventTempList),
          pointTrackList: (res.programmedScheduleMedia.pointTrackList || []).map((item) => {
            item.point = `${item.point}`
            item.trackDisabled = item.serviceProvider === this.ownProvider.provider
            return item
          }),
        }
        if (this.scheduleForm.supportMode === 2) {
          const backupEvent = setTargetEventDetail(res.programmedScheduleMedia, this.eventTempList, true)
          model.backupShipType = backupEvent.shipType
          model.backupTargetEvent = backupEvent.targetEvent
        }
        if (
          model.trackListLanding.length > 0 ||
          model.clickTrackListLanding.length > 0 ||
          model.startTrackListLanding.length > 0 ||
          model.middleTrackListLanding.length > 0 ||
          model.endTrackListLanding.length > 0
        ) {
          this.landingTrackType = 1
        }

        if (model.mobileTrackList && model.mobileTrackList.length > 0) {
          model.useMobileTrack = 1
        } else {
          model.useMobileTrack = 0
          model.mobileTrackList = [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
        }

        // 如果素材列表是空且没返回提示语，则显示默认提示语
        if (model.mediaList.length === 0 && !model.tipsDetail) {
          model.tipsTempId = this.defaultTipsTempId
          model.tipsDetail = this.filterDefaultTips(this.defaultTipsDetail)
        }
        if (model.landingTipsDetail && model.landingTipsDetail[0]) {
          model.landingTipsDetail = model.landingTipsDetail.map(tips => tips.replace(/\\"/g, '"'))
        } else {
          model.landingTipsDetail = ['']
        }
        this.$set(this, 'creativeModel', model)
      })
    },
    filterDefaultTips(tipsDetail) {
      if (tipsDetail) {
        const tipsList = JSON.parse(tipsDetail)
        const filteredList = tipsList.filter(item => [4, 3, undefined].includes(item.relatedTargetType))
        return filteredList.length ? JSON.stringify(filteredList) : ''
      }
      return ''
    },
    getRecStreamInfo() {
      this.$service.getRecStreamInfo({ recId: this.scheduleForm.recId }).then(res => {
        this.recStreamInfo = res || null
      })
    },
    getProviderMap() {
      const scheduleId = this.scheduleForm.scheduleId
      this.$service.getAvailProviderList({ scheduleId }).then((res) => {
        this.providerList = res || []
        if (this.providerList) {
          let providerMap = new Map()
          this.providerList.forEach((item) => {
            providerMap.set(item.providerNo, item.checkCode)
          })
          this.providerMap = providerMap
        }
      })
    },
    getOwnTrackProvider() {
      this.$service
        .getCoocaaTrack({ trackType: 'track' })
        .then((res) => {
          if (res) {
            this.ownProvider = res || {}
          }
        })
    },
    getCodeMacroMap() {
      this.$service.getCodeMacroMap().then((data) => {
        this.macroMap = data.codeMacroMap
      })
    },
    handleBackupShipTypeChange(val) {
      if (val === 'NONE') {
        this.creativeModel.backupTargetEvent = genTargetEvent()
      }
    },
    handleShipTypeChange(val) {
      if (val === 'NONE') {
        this.creativeModel.targetEvent = genTargetEvent()
        this.handleTargetEventChange(4)
      }
    },
    handleTargetEventChange(targetEventType) {
      const model = this.creativeModel
      model.targetEventType = targetEventType
      if (model.tipsTempId === undefined && model.tipsDetail !== '') {
        this.$alert('由于交互事件类型变更，提示语将清空，请重新设置', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.creativeModel.tipsTempId = undefined
            this.creativeModel.tipsDetail = ''
          }
        })
      }
    },
    // 保存提示语
    saveTips(data) {
      this.creativeModel.tipsTempId = data.tipsTempId
      this.creativeModel.tipsDetail = data.tipsDetail
    },
    confirmClearCodeType(val) {
      let hasCode = this.isTrackIsEmpty()
      if (val === 0 && hasCode) {
        this.$confirm('切换监测代码使用方式将删除已填写的监测代码，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.creativeModel.trackList = []
            this.creativeModel.clickTrackList = []
            this.creativeModel.startTrackList = []
            this.creativeModel.middleTrackList = []
            this.creativeModel.endTrackList = []
            this.creativeModel.pointTrackList = []
            this.codeType = val
          })
          .catch(() => {
            this.codeType = 1
          })
      }
    },
    isTrackIsEmpty() {
      const trackTypes = ['trackList', 'clickTrackList', 'startTrackList', 'middleTrackList', 'endTrackList']
      return trackTypes.every(trackType => {
        return this.creativeModel[trackType].every(item => {
          return item.code && item.serviceProvider
        })
      })
    },
    handleUseMobileTrackChange(val) {
      if (val === 0) {
        this.creativeModel.mobileTrackList = [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
      }
    },
    handleMobileTrackDel(index) {
      if (this.creativeModel.mobileTrackList.length > 1) {
        this.creativeModel.mobileTrackList.splice(index, 1)
      } else {
        this.creativeModel.mobileTrackList = [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
      }
    },
    handleMobileTrackAdd() {
      this.creativeModel.mobileTrackList.push({
        trackTypeModel: 1,
        serviceProvider: '',
        code: ''
      })
    },
    handleStTypeChange() {
      this.creativeModel.settlementProvider = ''
    },
    handleSelectedMedia(list) {
      if (this.brandIcon === 1) {
        const lackMinIconIds = list.filter(item => item.mediaClassId === 2 && !item.minIcon).map(item => item.mediaId)
        if (lackMinIconIds.length) {
          this.$message.error(`素材${lackMinIconIds.join('、')}缺少封面图，建议您前往【素材库】编辑素材添加该内容`)
          return
        }
      }
      if (list.length === 0) {
        this.creativeModel.mediaList = []
        this.showMediaDialog = false
        return
      }

      const preciousList = this.cloneDeep(this.creativeModel.mediaList)
      const preciousIds = preciousList.map(item => item.mediaId)
      let mediaIds = list.map(item => item.mediaId)
      // 排除已选的素材id去查mateHash
      if (preciousList.length > 0) {
        mediaIds = mediaIds.filter(item => !preciousIds.includes(item))
      }
      if (mediaIds.length === 0) {
        const newMediaIds = list.map(item => item.mediaId)
        this.creativeModel.mediaList = preciousList.filter(item => newMediaIds.includes(item.mediaId))
        this.showMediaDialog = false
        return
      }
      this.$service.getMediaByIds(mediaIds).then(res => {
        const mateHashObj = uniqBy(res, 'mateId').reduce((prev, cur) => {
          prev[cur.mateId] = {
            mateType: cur.mateType,
            mateHash: cur.mateHash
          }
          return prev
        }, {})
        this.creativeModel.mediaList = list.map(item => {
          const preciousItem = preciousList.find(media => media.mediaId === item.mediaId)
          if (preciousItem) {
            return preciousItem
          }
          const mateObj = mateHashObj[item.mediaId]
          return {
            ...item,
            mateCheckCode: '',
            mateType: mateObj ? mateObj.mateType : 'coocaa_id',
            mateHash: mateObj ? mateObj.mateHash : ''
          }
        })
        this.showMediaDialog = false
      })
    },
    handleMediaListChange(mediaList) {
      const backupMediaId = mediaList.findIndex(item => item.mediaId === this.creativeModel.backupMediaId)
      if (backupMediaId === -1) {
        this.creativeModel.backupMediaId = ''
      }
    },
    handleLandingTrackTypeChange(val) {
      if (val === 0) {
        this.creativeModel.trackListLanding = []
        this.creativeModel.clickTrackListLanding = []
        this.creativeModel.startTrackListLanding = []
        this.creativeModel.middleTrackListLanding = []
        this.creativeModel.endTrackListLanding = []
      }
    },
    setLandingPageTips(data) {
      this.creativeModel.landingTipsDetail = [data]
    },
    async saveCreative() {
      if (!await this.validateCreative()) return
      const params = this.buildApiParam()
      this.saveLoading = true
      this.$service
        .saveProgrammaticMaterial(params, '操作成功')
        .then((data) => {
          this.saveLoading = false
          this.$emit('go-back')
        })
        .catch(() => {
          this.saveLoading = false
        })
    },
    buildApiParam() {
      const model = this.creativeModel
      const publicModel = this.cloneDeep(model)
      const existTargetEvent = model.shipType !== 'NONE' && model.targetEvent.targetTempId > -1
      publicModel.landingTipsDetail = (existTargetEvent && model.landingTipsDetail.length && model.landingTipsDetail[0] !== '')
        ? model.landingTipsDetail[0]
        : undefined
      if (!existTargetEvent) {
        publicModel.trackListLanding = []
        publicModel.clickTrackListLanding = []
        publicModel.startTrackListLanding = []
        publicModel.middleTrackListLanding = []
        publicModel.endTrackListLanding = []
      }
      if (model.useMobileTrack === 0) {
        publicModel.mobileTrackList = []
      }
      if (this.scheduleForm.supportMode !== 2) {
        publicModel.trackList = []
        publicModel.clickTrackList = []
        publicModel.startTrackList = []
        publicModel.middleTrackList = []
        publicModel.endTrackList = []
        publicModel.pointTrackList = []
      }
      publicModel.keyEventList = model.shipType === 'KEY' ? [model.targetEvent] : [genTargetEvent()]
      publicModel.voiceEventList = model.shipType === 'VOICE' ? [model.targetEvent] : [genTargetEvent()]
      publicModel.autoEventList = model.shipType === 'AUTO' ? [model.targetEvent] : [genTargetEvent()]
      if (this.scheduleForm.supportMode === 2) {
        publicModel.backupKeyEventList = model.backupShipType === 'KEY' ? [model.backupTargetEvent] : [genTargetEvent()]
        publicModel.backupVoiceEventList = model.backupShipType === 'VOICE' ? [model.backupTargetEvent] : [genTargetEvent()]
        publicModel.backupAutoEventList = model.backupShipType === 'AUTO' ? [model.backupTargetEvent] : [genTargetEvent()]
      }
      delete publicModel.shipType
      delete publicModel.targetEventType
      delete publicModel.targetEvent
      delete publicModel.backupShipType
      delete publicModel.backupTargetEvent
      delete publicModel.settlementType
      delete publicModel.settlementProvider
      delete publicModel.mediaList
      delete publicModel.backupMediaId
      return {
        scheduleId: this.scheduleForm.scheduleId,
        partnerId: this.scheduleForm.partnerId,
        exposureMode: 1,
        shareTrack: 1,
        settlementType: model.settlementType,
        settlementProvider: model.settlementType !== 0 ? model.settlementProvider : '',
        backupMediaId: this.scheduleForm.supportMode === 2 ? model.backupMediaId : undefined,
        operateFlag: 2,
        mediaAddUpdateVOList: model.mediaList.map(item => {
          item.mateCheckCode = item.mateType === 'coocaa_id'
            ? `coocaa_${item.mediaId}`
            : (item.mateType === '自定义' ? item.mateCheckCode : item.mateHash)
          return item
        }),
        programmedScheduleMedia: {
          spaceId: this.scheduleForm.spaceId,
          ...publicModel,
          tipsTempId: model.tipsDetail === '' ? undefined : -1
        }
      }
    },
    // 程序化创意校验
    async validateCreative() {
      const isValid = await this.$refs.creativeForm.validate().catch(() => {})
      if (!isValid) return false

      const model = this.creativeModel

      // 校验交互事件
      let targetEvent = model.targetEvent
      let existTargetEvent = model.shipType !== 'NONE' && targetEvent.targetTempId > -1
      let isVoiceEvent = model.shipType === 'VOICE' && targetEvent.targetTempId > -1
      // 语音触发校验唤醒词
      if (isVoiceEvent && !targetEvent.voiceWord) {
        this.$message.error('语音触发的唤醒词不能为空!')
        return false
      }
      // 校验按键、语音、自动事件的扩展参数
      if (existTargetEvent) {
        const eventErr = checkTargetEvent(targetEvent)
        if (eventErr) {
          this.$message.error(eventEnum[this.creativeModel.shipType].name + eventErr)
          return false
        }
      }

      // 校验打底交互事件
      if (this.scheduleForm.supportMode === 2) {
        const backupTargetEvent = model.backupTargetEvent
        if (model.backupShipType === 'VOICE' && backupTargetEvent.targetTempId > -1 && !backupTargetEvent.voiceWord) {
          this.$message.error('打底交互事件语音触发的唤醒词不能为空!')
          return false
        }
        if (model.backupShipType !== 'NONE' && backupTargetEvent.targetTempId > -1) {
          const eventErr = checkTargetEvent(backupTargetEvent)
          if (eventErr) {
            this.$message.error(eventEnum[this.creativeModel.backupShipType].name + eventErr)
            return false
          }
        }
      }

      // 校验监测代码
      let trackErrMsg = ''
      trackErrMsg = checkTrackCode(model, '', this.macroMap, this.providerMap, this.ownProvider)
      if (trackErrMsg) {
        this.$message.error(trackErrMsg)
        return false
      }

      if (this.scheduleForm.supportMode === 2 && model.trackList.length === 0) {
        this.$message.error('保价全量的计划单，曝光监测代码必填!')
        return false
      }

      trackErrMsg = checkTrackCode(model, 'Landing', this.macroMap, this.providerMap, this.ownProvider)
      if (trackErrMsg) {
        this.$message.error(`落地页${trackErrMsg}`)
        return false
      }

      // 校验移动端监测代码
      if (this.showMobileTrack && model.useMobileTrack === 1) {
        let isComplete = true
        let isCorrect = true
        model.mobileTrackList.forEach(track => {
          if (!track.serviceProvider || !track.code) {
            isComplete = false
          }
          if (!checkRegEx(track.code)) {
            isCorrect = false
          }
        })
        if (!isComplete) {
          this.$message.error('移动端监测代码填写不完整!')
          return false
        }
        if (!isCorrect) {
          this.$message.error('移动端监测代码格式有误!')
          return false
        }
      }

      // 校验定点监测
      if (this.supportPointTrack && model.pointTrackList) {
        const ownTrackPoints = []
        const hasInvalidTime = model.pointTrackList.some((track) => {
          if (!track.point) {
            this.$message.error('定点监测时间不能为空')
            return true
          }
          const isOverTime = model.mediaList.some(media => parseInt(track.point) > media.duration)
          if (isOverTime) {
            this.$message.error('定点监测时间不能>素材时长')
            return true
          }
          if (this.ownProvider.provider === track.serviceProvider && track.point) {
            if (ownTrackPoints.includes(track.point)) {
              this.$message.error(`定点监测${track.point}秒自有监测只能有一个!`)
              return true
            }
            ownTrackPoints.push(track.point)
          }
          return false
        })
        if (hasInvalidTime) {
          return false
        }
      }

      // 校验素材列表
      if (model.mediaList.length === 0) {
        this.$message.error('未选择素材!')
        return false
      }
      const checkCodeNeeded = model.mediaList.some(item => {
        if (item.mateType === '自定义' && !item.mateCheckCode) {
          this.$message.error(`素材 ${item.mediaId}未填入物料校验码!`)
          return true
        }
      })
      if (checkCodeNeeded) return false
      const mediaCheckCodes = model.mediaList.map(item => this.getCheckCode(item))
      if (uniq(mediaCheckCodes).length !== model.mediaList.length) {
        this.$message.error('物料校验码不能相同!')
        return false
      }

      if (model.tipsDetail) {
        const tipsList = JSON.parse(model.tipsDetail)
        const tipsValid = tipsList.every(tip => {
          if (tip.type === 'txt') {
            return tip.showTime !== '' && tip.endTime !== '' && tip.marginX !== '' && tip.marginY !== '' && tip.content !== ''
          }
          return tip.showTime !== '' && tip.endTime !== '' && tip.marginX !== '' && tip.marginY !== '' && tip.content !== '' &&
            tip.width !== undefined && tip.height !== undefined
        })
        if (!tipsValid) {
          this.$message.error('提示语参数校验不完整, 请检查！')
          return false
        }
      }
      return true
    },
    getCheckCode(media) {
      return media.mateType === 'coocaa_id'
        ? `coocaa_${media.mediaId}`
        : (media.mateType === '自定义' ? media.mateCheckCode : media.mateHash)
    },
    handleGoBack() {
      this.$confirm('返回页面内容不会保存，确定要离开吗？', '提示', {
        confirmButtonText: '离开页面',
        cancelButtonText: '留在页面',
        center: true,
        type: 'warning'
      })
        .then(() => {
          this.$emit('go-back')
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-select, .el-input
  width 100%
.card-custom-title
  display flex
  flex-flow row nowrap
  justify-content space-between
  padding 16px 24px
  width 100%
  .card-custom-icon
    cursor pointer
    color #333
    &:hover
      color #ff8b00
.event-wrapper
  border 1px solid #e5e5e5
  border-radius 4px
  padding 16px
.flex-form-item
  display flex
  gap 10px
  margin-bottom 12px
  .el-select
    flex 0 0 140px
  .el-input
    flex-grow 1
</style>
